<template>
  <div class="time-picker">
    <div class="picker">
      <div class="row">
        <div class="col-12">
          <div v-if="isUsingChromium()">
            <input
                type="time"
                :value="selectedTime"
                @blur="selectTimeFromEvent($event)"
                class="form-control"
            >
          </div>
          <div v-else>
            <input
                type="time"
                :value="selectedTime"
                @input="selectTimeFromEvent($event)"
                @blur="selectTimeFromEvent($event)"
                class="form-control"
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {isChromiumBrowser} from '../helpers/IsChromiumBrowser.js'
export default {
  name: 'time-picker',
  props: ['initTime'],
  data() {
    return {
      selectedTime: null
    }
  },
  created() {
    if (this.initTime && this.initTime !== true) {
      this.selectTime(this.initTime)
    } else {
      if (this.initTime === true) {
        this.selectTime(this.$moment().format('HH:mm'))
      }
    }
  },
  methods: {
    isUsingChromium () {
      return isChromiumBrowser()
    },
      selectTime(time) {
          if (time) {
              let [hours, minutes] = time.split(":").map(Number);
              minutes = Math.round(minutes / 5) * 5;
              if (minutes === 60) {
                  minutes = 0;
                  hours += 1;

                  if (hours === 24) {
                      hours = 0;
                  }
              }
              let roundedHours = ('0' + hours).slice(-2);
              let roundedMinutes = ('0' + minutes).slice(-2);

              this.selectedTime = null
              this.selectedTime = `${roundedHours}:${roundedMinutes}`
          } else {
              this.selectedTime = null
          }
      },
    selectTimeFromEvent (event) {
      const time = event.srcElement.value
      if (time) {
        this.selectTime(time)
      } else {
        this.selectTime(null)
      }
    }
  },
  watch: {
    selectedTime (newTime) {
      this.$emit('selectTime', newTime)
    }
  }
}
</script>

<style scoped>
.form-control {
  color: #1b1e21;
  background-color: #fff;
  position: relative;
  border-radius: 0.25rem;
  border: 1px solid #c6c8ca;
  margin: 0;
}
.picker {
  width: 100%;
}
</style>
